module.exports = __webpack_public_path__ + "img/salsa_1310.ed0f2840.jpg";